<div class="ws-screen-body">
  <img [src]="logo" id="logoImage" />
</div>
